export default "/assets/005761125a7835516a3db993c2073ced.woff2";